import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import buildAdminServiceDetailQueryKey from '../helpers/buildAdminServiceDetailQueryKey';
import collectUnsupportedAdminServiceBilling from '../helpers/collectUnsupportedAdminServiceBilling';
import normalizeAdminServiceFromApi from '../helpers/normalizeAdminServiceFromApi';
import type {
    AdminServiceEnvelope,
    AdminServiceUnsupportedBillingError,
    LiveAdminService,
    UseGetAdminServiceParams,
    UseGetAdminServiceResult,
} from '../types';

const useGetAdminService = ({ serviceId }: UseGetAdminServiceParams): UseGetAdminServiceResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<AdminServiceEnvelope>({
        pathname: `/admin/services/${encodeURIComponent(serviceId)}`,
        method: 'GET',
        key: buildAdminServiceDetailQueryKey({ serviceId }),
        queryOptions: {
            enabled: serviceId.length > 0,
        },
    });

    let service: LiveAdminService | null = null;
    let unsupportedBillingError: AdminServiceUnsupportedBillingError | undefined;

    if (data?.data.service) {
        try {
            service = normalizeAdminServiceFromApi({ dto: data.data.service });
        } catch (caughtError) {
            unsupportedBillingError = collectUnsupportedAdminServiceBilling({
                caughtError,
            });
        }
    }

    return {
        service,
        isLoadingService: isLoading,
        error: unsupportedBillingError || error || undefined,
        refetch,
    };
};

export default useGetAdminService;
